import styles from "./Trends.module.css";
import React from "react";

export type BarColumnProps = {
  barData: any;
  index: number;
  rowIndex: number;
};

export const BarColumn = (props: BarColumnProps) => {
  const barDelay = props.index * 0.08 + props.rowIndex * 0.05;
  const h = props.barData.totalHeight;

  if (!props.barData.segments || props.barData.segments.length === 0) {
    return (
      <div className={styles["bar-item"]} style={{ height: `${h}px` }}>
        <div
          className={styles["bar-empty-placeholder"]}
          style={{ height: `${h}px` }}
          aria-hidden
        />
      </div>
    );
  }

  return (
    <div className={styles["bar-item"]} style={{ height: `${h}px` }}>
      {props.barData.segments.map((segment: any, segmentIndex: number) => {
        const isFirst = segmentIndex === 0;
        const isLast = segmentIndex === props.barData.segments.length - 1;
        const radiusClass =
          isFirst && isLast
            ? styles["bar-segment--only"]
            : isFirst
              ? styles["bar-segment--first"]
              : isLast
                ? styles["bar-segment--last"]
                : "";
        return (
          <div
            key={segmentIndex}
            className={`${styles["bar-segment"]} ${radiusClass}`.trim()}
            style={{
              backgroundColor: segment.color,
              animationDelay: `${barDelay + segmentIndex * 0.1}s`,
              height: `${segment.height}px`,
            }}
          />
        );
      })}
    </div>
  );
};
